// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"758":"1c27b4bb","898":"d3fda8da"}[chunkId] + ".chunk.js";
};